import { Alert } from 'antd'
import styled from 'styled-components'

const StyledAlert = styled(Alert)`
  padding: 0 !important;
`
export default StyledAlert
